module.exports = __webpack_public_path__ + "static/media/prescription-bottle-alt.7869cd91.svg";